import classNames from "classnames"
import * as React from "react"
import { useState } from "react"

import { Analytics } from "@bounce/analytics"
import { useTranslation } from "@bounce/i18n"

import { InteractionEvents } from "../../../../../libs/analytics/events"
import type { FormattedEvent } from "../../../../../libs/prismic/types"

import ArrowIcon from "./assets/arrow.svg"
import CheckIcon from "@bounce/assets/icons/Check.svg"
import ClipboardIcon from "@bounce/assets/icons/Clipboard.svg"

export type CouponBannerProps = {
  event: FormattedEvent
  className?: string
}

export const CouponBanner = ({ event, className }: CouponBannerProps) => {
  const { t } = useTranslation("marketing-ls-event")
  const [copiedCode, setCopiedCode] = useState(false)

  const copyCode = async () => {
    await navigator.clipboard.writeText(event.couponCode)
    setCopiedCode(true)
    Analytics.track(InteractionEvents.EventCopiedDiscountCode, { discountCode: event.couponCode })
  }

  return (
    <section className={classNames("w-full bg-neutral-100 py-[60px]", className)}>
      <div className="mx-auto flex w-full max-w-screen-xl flex-col items-center px-6 md:flex-row">
        <div className="flex w-full flex-col justify-center">
          <h2 className="title2 text-center md:whitespace-pre md:text-left">
            {t("screen.event.storeSuggestions.discount.titleV2", "{{eventName}} \nexclusive discount", {
              eventName: event.name,
            })}
          </h2>
          <p className="paragraph1 mt-2 max-w-4xl text-center text-neutral-800 md:mt-2.5 md:text-left xl:mt-3">
            {t("screen.event.storeSuggestions.discount.description", "Get 10% off your {{eventName}} luggage storage", {
              eventName: event.name,
            })}
          </p>
          <div className="flex w-full justify-center md:justify-start">
            <button className="mt-12 flex flex-col" onClick={copyCode}>
              <span className="title6">{event.couponCode}</span>
              <div className="mt-1 flex flex-row items-center justify-center">
                {copiedCode ? (
                  <CheckIcon className="size-5 text-primary-700" />
                ) : (
                  <ClipboardIcon className="size-5 text-primary-700" />
                )}
                <span className="ml-2 font-medium text-primary-700">
                  {copiedCode
                    ? t("screen.event.storeSuggestions.discount.copied", "Copied")
                    : t("screen.event.storeSuggestions.discount.copy", "Copy")}
                </span>
              </div>
            </button>
            <div className="relative left-2 top-5 hidden md:flex">
              <ArrowIcon height={46} />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
